const globalStyleId = 'gs-text-main';
const globalStyleIdSecondary = 'gs-text-secondary';
const defaultSelector = {
  selector: '#{mID} .gf_btn-upload',
};
const secondarySelector = {
  selector: '#{mID} .gf_btn-secondarytext',
};
export default {
  defaultClass: 'gf_gs-text-paragraph-1',
  settingGroups: {
    [globalStyleIdSecondary]: {
      secondarySize: {
        ...secondarySelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      secondaryFont: {
        ...secondarySelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
      secondaryFontStyle: {
        ...secondarySelector,
        inherit: 'text.fontStyle',
        cssAttr: 'font-style',
      },
      // "secondaryColor": {
      //   ...secondarySelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
    },
    [globalStyleId]: {
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
      'font-style': {
        ...defaultSelector,
        inherit: 'text.fontStyle',
        cssAttr: 'font-style',
      },
    },
  },
};

export const P_FILE_UPLOAD_SETTING = [
  {
    gsId: globalStyleIdSecondary,
    gsSettingGroup: 'Secondary Text Settings',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'paragraph',
    isSettingAdvand: true,
  },
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    prefix: 'gf_gs-text-',
    typeSetting: 'paragraph',
  },
];
